"use client";

import type { Article } from "@/types/insights";
import ArticleCard from "./ArticleCard";

/** Responsive grid of article cards. */
export default function ArticleList({ articles }: { articles: Article[] }) {
  return (
    <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {articles.map((a, i) => (
        <ArticleCard key={a.id} article={a} i={i} />
      ))}
    </div>
  );
}
